import { useQuery } from '@tanstack/react-query'
import { listTestimonials } from '../api/testimonials'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import { mapTestimonialCard, sortBySortOrder, type TestimonialCard } from '../helpers/mapContent'

type TestimonialsState = {
  testimonials: TestimonialCard[]
  loading: boolean
  error: string | null
}

export function useTestimonials(): TestimonialsState {
  const testimonialsQuery = useQuery({
    queryKey: QUERY_KEYS.testimonials,
    queryFn: () => listTestimonials(true, true),
  })
  const error = testimonialsQuery.error
    ? toApiMessage(testimonialsQuery.error, 'Failed to load testimonials')
    : null

  return {
    testimonials: sortBySortOrder(testimonialsQuery.data ?? []).map(mapTestimonialCard),
    loading: testimonialsQuery.isPending && !testimonialsQuery.data && !error,
    error,
  }
}
